import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { QuestionCompact } from '@ratehub/base-ui';
import { INTENDED_USE } from '@ratehub/documents/mtg-journey-document/stable';

import INTENDED_USE_MESSAGES from '../definitions/IntendedUsageMessages';


function QuestionOccupancy({ name, value, ...otherProps }) {
    return (
        <QuestionCompact
            field={{
                name: name,
                type: 'choice',
                value: value,
                options: Object.values(INTENDED_USE),
            }}
            renderOptionLabel={value => (
                <FormattedMessage
                    {...INTENDED_USE_MESSAGES[value]}
                />
            )}
            labelMessage={(
                <FormattedMessage
                    id="web-components.mortgageRateTableV2+Filter.occupancyLabel"
                    defaultMessage="Occupancy"
                />
            )}
            type="dropdown"
            {...otherProps}
        />
    );
}

QuestionOccupancy.propTypes = {
    name: PropTypes.string,
    value: PropTypes.oneOf(Object.values(INTENDED_USE)),
};

QuestionOccupancy.defaultProps = {
    name: 'occupancy',
    value: undefined,
};

export default QuestionOccupancy;